export const PAID_EVENT_CATALOG_REFRESH_MS = 15_000;

export function shouldPollPaidEventCatalog(data: unknown, isVisible: boolean): boolean {
  if (!isVisible || !Array.isArray(data)) return false;
  return data.some(event =>
    typeof event === "object" &&
    event !== null &&
    (
      ("registrationMode" in event && event.registrationMode === "paid") ||
      ("seatsRemaining" in event && typeof event.seatsRemaining === "number")
    ),
  );
}

/** React Query interval callback shared by the live event catalog surfaces. */
export function paidEventCatalogRefetchInterval(query: { state: { data: unknown } }): number | false {
  const isVisible = typeof document === "undefined" || document.visibilityState !== "hidden";
  return shouldPollPaidEventCatalog(query.state.data, isVisible) ? PAID_EVENT_CATALOG_REFRESH_MS : false;
}
